// extracted by mini-css-extract-plugin
export default {"container":"_2R2HQ_oMHXHdJDbyqhiJlj","banner":"_24AIJ78NA2PRg3xJcETZTw","cta":"_11r4D1owe9aY8CmqVRENZv","logo":"_1hvnXump-ViiioPr0nDC5w"};